import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import PersonaDialog from './PersonaDialog';
import MobilityNeedsOverlay from '../molecules/MobilityNeedsOverlay';
import type { Persona } from '../../data/Personas';

export interface Props {
	persona: Persona;
	onClose: () => void;
}

const PersonaDetailsDialog: FunctionComponent<Props> = (props: Props) => {
	const { onClose, persona } = props;
	const { t } = useTranslation();
	const text: string[] = t(persona.texts.description, { returnObjects: true });
	const needs: string[] = t(persona.texts.shortDescription, {
		returnObjects: true
	});

	return (
		<PersonaDialog persona={persona} text={text} onClose={onClose}>
			<MobilityNeedsOverlay needs={needs} />
		</PersonaDialog>
	);
};

export default PersonaDetailsDialog;
